import React, { createContext, useReducer } from "react";
import { CartReducer, sumItems } from "./CartReducer";
import { Logininfo } from "../shared/swipeabledrawer"

export const CartContext = createContext();


// initialState = { cartItems: [], ...sumItems([]), checkout: false };

const CartContextProvider = ({ children }) => {

  let qrcodeid = "1";
  try {
    qrcodeid = localStorage.getItem("cartId");
  } catch (ex) { }

  let storage;
  let initialState;

  storage = localStorage.getItem("cart" + qrcodeid + "")
    ? JSON.parse(localStorage.getItem("cart" + qrcodeid + ""))
    : [];
  qrcodeid = localStorage.getItem("cartId");
  initialState = { cartItems: storage, ...sumItems(storage), checkout: false };
  let [state, dispatch] = useReducer(CartReducer, initialState);

  const [userInfo, setUserInfo] = React.useState({
    guestName: '',
    mobileNo: '',
    otpValue: '',
    loginFlag: false
  });

  const increase = (payload, data) => {

    dispatch({ type: "INCREASE", payload, data });
  };
  const cartincrease = (payload, data) => {

    let addoncontent = payload.addoncontent;
    dispatch({ type: "CART_INCREASE", payload, addoncontent });
  };
  const decrease = (payload) => {

    dispatch({ type: "DECREASE", payload });
  };
  const cartdecrease = (payload, data) => {

    let addoncontent = payload.addoncontent;
    dispatch({ type: "CART_DECREASE", payload, addoncontent });
  };

  const addProduct = (payload) => {
    dispatch({ type: "ADD_ITEM", payload });
  };

  const addCustomizeProduct = (payload, addonselectedid, total, addonselectedname) => {
    dispatch({ type: "CUSTOMIZE_ADD_ITEM", payload, addonselectedid, total, addonselectedname });
  };

  const removeProduct = (payload) => {

    dispatch({ type: "REMOVE_ITEM", payload });
  };
  const cartremoveProduct = (payload, data) => {

    dispatch({ type: "CART_REMOVE_ITEM", payload, data });
  };



  const clearCart = () => {
    dispatch({ type: "CLEAR" });
  };

  const handleCheckout = () => {
    console.log("CHECKOUT", state);
    dispatch({ type: "CHECKOUT" });
  };
  const ADDInstructions = (payload, data) => {

    dispatch({ type: "ADD_Instructions", payload, data });
  };
  const loginUserInfo = (userInfo) => {

    setUserInfo({ guestName: userInfo.guestName, mobileNo: userInfo.mobileNo, otpValue: userInfo.otpValue, loginFlag: userInfo.loginFlag });
    //alert(userInfo.guestName +'  '+userInfo.mobileNo +' '+ userInfo.otpValue +' '+ userInfo.loginFlag);
    Logininfo(userInfo.guestName, userInfo.mobileNo)
  };
  const cartadd = () => {

    alert("test");

  };

  const contextValues = {
    removeProduct,
    addProduct,
    increase,
    cartincrease,
    decrease,
    cartdecrease,
    clearCart,
    handleCheckout,
    ...state,
    loginUserInfo,
    ADDInstructions,
    cartremoveProduct,
    addCustomizeProduct,
    cartadd
  };

  return (
    <CartContext.Provider value={contextValues}>
      {children}
    </CartContext.Provider>
  );
};

export default CartContextProvider;
